const HeroSection = () => {
  const handleContactClick = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleServicesClick = () => {
    window.REACT_APP_NAVIGATE('/services');
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/d0c109e102b921c4ee8d7611890caf6b.jpg)',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative max-w-[1280px] mx-auto px-6 py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3">
            <div className="inline-block bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <span className="text-sm text-[#0A1628] font-medium">Est. 2022 · Portugal</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Where sport meets<br />
              people<br />
              performance
            </h1>

            <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-2xl">
              HR consultancy built for sports organisations and professionals
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={handleContactClick}
                className="bg-[#0066FF] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#0052CC] transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                Start Conversation
              </button>
              <button
                onClick={handleServicesClick}
                className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
              >
                Explore Services
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
